import Vue from 'vue';
import App from './App.vue';

import router, { resetRouter } from "./router";
import i18n from "@/i18n/index";
import store from "./store";
import preventReClick from '@/directive/noDbClick';
import permission from '@/directive/permission';
import VueClipboard from 'vue-clipboard2';
import notify from '@/components/Notify';
import './icons';
import './icons/iconfont/iconfont.js';
import './icons/iconfont/iconfont.css';
import VueSanitize from "vue-sanitize";
import '@/styles/index.scss'; // global css

// import './utils/error-log'; // error log
import './permission'; // permission control

import * as filters from './filters'; // global filters
import './public-path';
import registerGlobalModule from './qiankunglobal';
import { resetBaseUrl } from '@/utils/request';
import HanshowUI from "@hs/hanshow-ui";

Vue.use(HanshowUI);
Vue.use(preventReClick);
Vue.use(permission);
Vue.use(VueClipboard);
Vue.use(VueSanitize);
// register global utility filters
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});


Vue.config.productionTip = false;
Vue.prototype.$notify = notify;

// Vue.prototype.$httpList = http;


//qiankun
let instance = null;
let createrouter = null;
function render(props = {}) {
    const { container } = props;
    createrouter = router;
    let baseUrl = props.baseUrl || undefined;
    resetRouter(baseUrl);
    instance = new Vue({
        router: createrouter,
        i18n,
        store,
        render: (h) => h(App),
    }).$mount(container ? container.querySelector('#app') : '#app');

    // 无障碍访问
    // 全局监听键盘事件
    if (window.__POWERED_BY_QIANKUN__) {
        return;
    } else {
        toggleFocusStyles(true);
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
            // document.body.classList.add('keydown-mode');
            document.body.classList.remove('mouse-mode');
        }
    });

    // 全局监听鼠标事件
    document.addEventListener('mousedown', () => {
        // document.body.classList.remove('keydown-mode');
        document.body.classList.add('mouse-mode');

        // 短时间后移除鼠标模式类
        // setTimeout(() => {
        //     document.body.classList.remove('mouse-mode');
        // }, 100);
    });

    // 全局监听触摸事件（移动设备）
    document.addEventListener('touchstart', () => {
        // document.body.classList.remove('keydown-mode');
        document.body.classList.add('mouse-mode');
        // setTimeout(() => {
        //     document.body.classList.remove('mouse-mode');
        // }, 100);
    });
}


// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
    render();
}

export async function bootstrap() {
    // console.log('[vue] vue app bootstraped');
}
export async function mount(props) {
    registerGlobalModule(store, props);
    if (window.__POWERED_BY_QIANKUN__) {
        resetBaseUrl();
    }

    store.commit('user/SET_ROLES', []);
    store.commit('app/SET_SHOWMENU', props.getGlobalState('showMenu'));

    if (props.getGlobalState().accessToken) {
        store.dispatch('user/unitaryLogin', { jsessionid: 'quankunlogin' });
    } else {
        store.dispatch('user/logoutClear', {});
    }
    if (props.getGlobalState('menuWidth')) {
        store.dispatch('app/changeMenuWidth', props.getGlobalState('menuWidth'));
    }

    const mountCustomer = props.getGlobalState('currentCustomer');
    const mountStore = props.getGlobalState('currentStore');
    async function setcode(customerCode, storeCode) {
        store.commit('app/SET_CURRENTCUSTOMER', customerCode);
        store.commit('app/SET_CURRENTSTORE', storeCode);
        if (!props.getGlobalState('servicePage')) {
            store.commit('app/SET_SHOW_REALM', 'GLOBAL');
            return;
        }
        if (customerCode != undefined && customerCode != '') {
            store.commit('app/SET_SHOW_REALM', 'SYSTEM');
            if (storeCode != undefined && storeCode != '') {
                store.commit('app/SET_SHOW_REALM', 'NORMAL');
            }
        } else {
            store.commit('app/SET_SHOW_REALM', 'GLOBAL');
        }

    }
    setcode(mountCustomer, mountStore);

    const hasLanguages = window.languages;
    let navigatorLanguage = navigator.language || navigator.browserLanguage;
    if (!hasLanguages[navigatorLanguage]) {
        navigatorLanguage = 'en';
    }
    let lang = window.localStorage.getItem('localeLanguage') ? window.localStorage.getItem('localeLanguage') : navigatorLanguage;
    Vue.prototype.$setup(lang);


    props.onGlobalStateChange((state,) => {
        store.commit('app/SET_SHOWMENU', state.showMenu);

        async function setCurrentCustomer(customerCode, storeCode) {
            let toDashboard = false;
            if (customerCode !== store.getters.choseCustomer || storeCode !== store.getters.choseStore) {
                toDashboard = true;
            }
            if (customerCode !== store.getters.choseCustomer) {
                await store.dispatch('app/setCurrentCustomer', { code: customerCode, dispatchGlobal: false });
                if (customerCode && storeCode !== store.getters.choseStore) {
                    store.dispatch('app/setCurrentStore', { code: storeCode, dispatchGlobal: false });
                }
            } else if (storeCode !== store.getters.choseStore) {
                store.dispatch('app/setCurrentStore', { code: storeCode, dispatchGlobal: false });
            }
            return toDashboard;
        }
        let currentAppName = state.currentAppName || '';
        if (currentAppName.toLowerCase() == 'prismart') {
            setCurrentCustomer(state.currentCustomer, state.currentStore).then((flag) => {
                if (flag) {
                    store.dispatch('app/routerName', { name: 'dashboardPage' });
                }

            });
        }

        if (state.currentLanguage) {

            let lang = store.getters.language;
            if (state.currentLanguage != lang) {
                let changeLang = state.currentLanguage;
                store.dispatch('app/getCustLanguage');
                Vue.prototype.$setup(changeLang);
            }
        }
    });
    render(props);
}
export async function unmount() {
    instance.$destroy();
    instance.$el.innerHTML = '';

    instance = null;
    createrouter = null;
}

function toggleFocusStyles(enable) {
    const styleElement = document.getElementById('focusStyles');

    if (enable) {
        // 如果 enable 为 true 且没有 styleElement，则添加
        if (!styleElement) {
            const style = document.createElement('style');
            style.id = 'focusStyles';
            style.innerHTML = `
        body:not(.mouse-mode) .el-button:focus,
        body:not(.mouse-mode) .el-input:focus,
        body:not(.mouse-mode) .el-select:focus,
        body:not(.mouse-mode) .el-radio:focus,
        body:not(.mouse-mode) .el-checkbox:focus,
        body:not(.mouse-mode) .el-button--primary:focus,
        body:not(.mouse-mode) .el-button--default:focus {
          outline: 2px solid #015AC5;
        }

        body:not(.mouse-mode) .el-button--text:focus {
          outline: 2px solid #015AC5;
          outline-offset: 2px;
        }

        body:not(.mouse-mode) .el-link:focus {
          box-shadow: inset 0 0 0 2px #015AC5;
        }

        body:not(.mouse-mode) .el-dialog__headerbtn:focus {
          outline: 2px solid #015AC5;
          outline-offset: 2px;
        }

        body:not(.mouse-mode) .dialog-footer .el-button:focus {
          outline: 2px solid #015AC5;
        }
      `;
            document.head.appendChild(style);
        }
    } else {
        // 如果 enable 为 false 且存在 styleElement，则移除
        if (styleElement) {
            styleElement.parentNode.removeChild(styleElement);
        }
    }
}
